<div class="mingleViewMoreNav">
	<a soho-hyperlink (click)="onViewMoreLink($event)">{{viewMore}}</a>
</div>